module.exports = __webpack_public_path__ + "media/images/icon-nodata-green-d942a3662d536b829900a59f4829bbd2.png";